import { render, staticRenderFns } from "./UploadPedidoArchivo.vue?vue&type=template&id=4183632e&"
import script from "./UploadPedidoArchivo.vue?vue&type=script&lang=js&"
export * from "./UploadPedidoArchivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports